/**
 * 底部 Tab 导航：redirectTo + 预加载，避免 reLaunch 整站重启与 AsyncLoading 骨架闪屏
 */
import { redirectTo } from '@/utils/router'
import { reloadForStaleChunks } from '@/utils/chunk-reload'

const MAIN_TAB_URLS: Record<string, string> = {
  home: '/pages/index/index',
  accumulate: '/pages/accumulate/index',
  trend: '/pages/quote/list',
  basis: '/pages/basis/index',
  flash: '/pages/flash/index',
  mine: '/pages/user/center',
}

export function switchMainTab(key: string): void {
  const url = MAIN_TAB_URLS[key]
  if (!url) return
  void redirectTo(url).catch(() => {
    // 发版后旧 chunk 失效时 redirectTo 失败，硬刷新拉最新入口（H5）
    reloadForStaleChunks(`tab:${key}`)
  })
}

/** App 启动后预拉取各 Tab 页 JS chunk，切换时不再出现 AsyncLoading */
export function preloadMainTabs(): void {
  for (const url of Object.values(MAIN_TAB_URLS)) {
    uni.preloadPage({
      url,
      fail: () => {},
    })
  }
}
